import React from 'react';

import { NoticeSnackbar } from './NoticeSnackbar';

interface IProps {
  open: boolean;
  message: string;
  onUndo: () => void;
  onClose: () => void;
}

export const UndoSnackbar: React.FC<IProps> = ({ open, message, onUndo, onClose }) => (
  <NoticeSnackbar open={open} message={message} onClose={onClose} actionLabel="Undo" onAction={onUndo} />
);
